import { useEffect, useState } from 'react';
import { api } from '../api';
import { Icone } from '../Icones.jsx';

const PERMS = [
  ['criar_os', 'Criar OS'], ['editar_os', 'Editar OS'], ['alterar_status', 'Alterar status'],
  ['ver_relatorios', 'Relatórios'], ['gerenciar_usuarios', 'Ger. usuários'],
];
const PERFIL_LABEL = { admin: 'Administrador', atendente: 'Atendente', expedicao: 'Expedição' };
const PERFIL_COR = { admin: 'var(--verde)', atendente: 'var(--amarelo)', expedicao: 'var(--azul)' };

const padrao = perfil => perfil === 'admin'
  ? { criar_os: 1, editar_os: 1, alterar_status: 1, ver_relatorios: 1, gerenciar_usuarios: 1 }
  : perfil === 'expedicao'
    ? { criar_os: 0, editar_os: 0, alterar_status: 1, ver_relatorios: 1, gerenciar_usuarios: 0 }
    : { criar_os: 1, editar_os: 1, alterar_status: 0, ver_relatorios: 0, gerenciar_usuarios: 0 };

export default function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [lojas, setLojas] = useState([]);
  const [novo, setNovo] = useState(null);
  const [trocarSenha, setTrocarSenha] = useState(null);
  const [erro, setErro] = useState('');
  const [ok, setOk] = useState('');

  const carregar = () => api('/usuarios').then(setUsuarios).catch(e => setErro(e.message));
  useEffect(() => { carregar(); api('/lojas').then(setLojas).catch(() => {}); }, []);

  const salvar = async () => {
    setErro('');
    try {
      await api('/usuarios', { method: 'POST', body: novo });
      setNovo(null);
      carregar();
    } catch (e) { setErro(e.message); }
  };

  const salvarSenha = async () => {
    setErro(''); setOk('');
    if (!trocarSenha.senha || trocarSenha.senha.length < 6)
      return setErro('A nova senha precisa ter pelo menos 6 caracteres.');
    try {
      await api(`/usuarios/${trocarSenha.id}`, { method: 'PATCH', body: { senha: trocarSenha.senha } });
      setOk(`Senha de ${trocarSenha.nome} alterada com sucesso.`);
      setTrocarSenha(null);
    } catch (e) { setErro(e.message); }
  };

  const togglePerm = async (u, k) => {
    try {
      await api(`/usuarios/${u.id}`, { method: 'PATCH', body: { perms: { ...u.perms, [k]: !u.perms[k] } } });
      carregar();
    } catch (e) { setErro(e.message); }
  };

  const trocarLoja = async (u, lojaId) => {
    try {
      await api(`/usuarios/${u.id}`, { method: 'PATCH', body: { loja_id: lojaId || null } });
      carregar();
    } catch (e) { setErro(e.message); }
  };

  const toggleAtivo = async u => {
    try {
      await api(`/usuarios/${u.id}`, { method: 'PATCH', body: { ativo: !u.ativo } });
      carregar();
    } catch (e) { setErro(e.message); }
  };

  return (
    <div>
      <div className="row" style={{ justifyContent: 'space-between', marginBottom: 14 }}>
        <h2>Usuários & Permissões</h2>
        {!novo && (
          <button className="btn" onClick={() => setNovo({ nome: '', login: '', senha: '', perfil: 'atendente', loja_id: '', perms: padrao('atendente') })}>
            + Novo usuário
          </button>
        )}
      </div>
      {erro && <div className="erro" style={{ marginBottom: 12 }}>{erro}</div>}
      {ok && <div className="sucesso" style={{ marginBottom: 12 }}>{ok}</div>}

      {novo && (
        <div className="card" style={{ background: 'var(--verde-claro)', marginBottom: 14 }}>
          <div className="row">
            <div style={{ flex: 1 }}><label className="label">Nome</label>
              <input className="input" value={novo.nome} onChange={e => setNovo({ ...novo, nome: e.target.value })} /></div>
            <div style={{ flex: 1 }}><label className="label">Login</label>
              <input className="input" value={novo.login} onChange={e => setNovo({ ...novo, login: e.target.value })} /></div>
            <div style={{ flex: 1 }}><label className="label">Senha</label>
              <input className="input" type="password" value={novo.senha} onChange={e => setNovo({ ...novo, senha: e.target.value })} /></div>
            <div style={{ flex: 1 }}><label className="label">Perfil</label>
              <select className="select" value={novo.perfil}
                onChange={e => setNovo({ ...novo, perfil: e.target.value, perms: padrao(e.target.value) })}>
                <option value="admin">Administrador</option>
                <option value="atendente">Atendente</option>
                <option value="expedicao">Expedição</option>
              </select></div>
            <div style={{ flex: 1 }}><label className="label">Loja</label>
              <select className="select" value={novo.loja_id} onChange={e => setNovo({ ...novo, loja_id: e.target.value })}>
                <option value="">— (expedição/admin)</option>
                {lojas.map(l => <option key={l.id} value={l.id}>{l.nome}</option>)}
              </select></div>
          </div>
          <div className="row" style={{ marginTop: 10 }}>
            <button className="btn" onClick={salvar}>Salvar usuário</button>
            <button className="btn-sec" onClick={() => setNovo(null)}>Cancelar</button>
          </div>
        </div>
      )}

      {trocarSenha && (
        <div className="card" style={{ background: 'var(--verde-claro)', marginBottom: 14 }}>
          <div className="row" style={{ alignItems: 'end' }}>
            <div style={{ flex: 1 }}>
              <label className="label">Nova senha de {trocarSenha.nome}</label>
              <input className="input" type="password" autoFocus value={trocarSenha.senha}
                onChange={e => setTrocarSenha({ ...trocarSenha, senha: e.target.value })}
                onKeyDown={e => e.key === 'Enter' && salvarSenha()} />
            </div>
            <button className="btn" onClick={salvarSenha}>Salvar senha</button>
            <button className="btn-sec" onClick={() => setTrocarSenha(null)}>Cancelar</button>
          </div>
        </div>
      )}

      <div className="card" style={{ overflowX: 'auto' }}>
        <table className="tbl">
          <thead>
            <tr>
              <th>Usuário</th><th>Perfil</th><th>Loja</th>
              {PERMS.map(([k, l]) => <th key={k} style={{ textAlign: 'center' }}>{l}</th>)}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {usuarios.map(u => (
              <tr key={u.id} style={{ opacity: u.ativo ? 1 : .45 }}>
                <td>
                  <div style={{ fontWeight: 700 }}>{u.nome}</div>
                  <div style={{ fontSize: 11.5, color: 'var(--cinza)' }}>@{u.login}</div>
                </td>
                <td><span className="badge" style={{ background: PERFIL_COR[u.perfil] + '22', color: PERFIL_COR[u.perfil] }}>{PERFIL_LABEL[u.perfil]}</span></td>
                <td>
                  <select className="select" style={{ minWidth: 150, fontSize: 12.5, padding: '5px 6px' }}
                    value={u.loja_id || ''} onChange={e => trocarLoja(u, e.target.value)}>
                    <option value="">— (todas as lojas)</option>
                    {lojas.map(l => <option key={l.id} value={l.id}>{l.nome}</option>)}
                  </select>
                </td>
                {PERMS.map(([k]) => (
                  <td key={k} style={{ textAlign: 'center' }}>
                    <input type="checkbox" checked={!!u.perms[k]} disabled={u.perfil === 'admin'}
                      onChange={() => togglePerm(u, k)}
                      style={{ accentColor: 'var(--verde)', width: 16, height: 16, cursor: 'pointer' }} />
                  </td>
                ))}
                <td style={{ whiteSpace: 'nowrap' }}>
                  <button className="btn-sec" style={{ marginRight: 6 }}
                    onClick={() => { setOk(''); setTrocarSenha({ id: u.id, nome: u.nome, senha: '' }); }}>
                    <Icone nome="chave" size={13} /> Senha
                  </button>
                  <button className="btn-sec" onClick={() => toggleAtivo(u)}>{u.ativo ? 'Desativar' : 'Ativar'}</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <p style={{ fontSize: 12, color: 'var(--cinza)', marginBottom: 0 }}>
          O perfil Administrador tem todas as permissões fixas. As permissões controlam o que cada usuário vê e pode fazer no sistema.
        </p>
      </div>
    </div>
  );
}
